// Static content for the ONE OF NONE site.
export const LOGO = "/jt-logo.png";

export const INQUIRY_TYPES = [
  "Brand Partnership",
  "Media / Interview",
  "Public Speaking Engagement",
  "Appearance / Event",
  "Podcast / Feature",
  "Other",
];

export const IMAGES = {
  heroPoster:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_one-of-none/artifacts/co1h1rwe_IMG_5728.jpeg",
  portrait:
    "https://customer-assets.emergentagent.com/job_one-of-none/artifacts/njqzotl4_Untitled_design.png",
  action:
    "https://customer-assets.emergentagent.com/job_one-of-none/artifacts/4ru51su0_IMG_6979.jpeg",
  headshot:
    "https://customer-assets.emergentagent.com/job_one-of-none/artifacts/70kh9vkt_IMG_6984.jpeg",
  airport:
    "https://customer-assets.emergentagent.com/job_one-of-none/artifacts/s2ctcazd_IMG_6993.jpeg",
  ireland:
    "https://customer-assets.emergentagent.com/job_one-of-none/artifacts/ibhxy74y_IMG_6986.jpeg",
  newcastle:
    "https://customer-assets.emergentagent.com/job_one-of-none/artifacts/6w0f34gn_IMG_6983.jpeg",
  yearThree:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_one-of-none/artifacts/rh4cn68b_IMG_7748.jpeg",
};

// Cinematic looping clip used as the hero background (placeholder stock footage).
export const HERO_VIDEO =
  "https://videos.pexels.com/video-files/3125907/3125907-uhd_2560_1440_30fps.mp4";

export const STATS = [
  { value: 2, suffix: "", label: "Professional Seasons" },
  { value: 2, suffix: "x", label: "Champion" },
  { value: 1, suffix: "x", label: "League MVP" },
  { value: 1, prefix: "#", label: "League Scorer" },
  { value: 1, suffix: "x", label: "All-Star Leading Scorer" },
  { value: 2, suffix: "nd", label: "Leading Scorer in Ireland (2024/25)" },
];

export const CHAPTERS = [
  {
    flag: "🇮🇪",
    place: "DUBLIN, IRELAND",
    year: "2024",
    headline: "The Leap.",
    copy: [
      "First year as a pro.",
      "New country. New environment. No comfort zone.",
      "I didn't know exactly what to expect. I just knew I belonged.",
      "That season taught me a lot about myself. And it reminded me that betting on yourself is always worth it.",
    ],
    achievements: [
      "Second Leading Scorer (2024/25)",
      "First Professional Contract",
      "International Debut",
    ],
    image: IMAGES.ireland,
    coords: { x: 30, y: 34 },
  },
  {
    flag: "🇬🇧",
    place: "NEWCASTLE, UK",
    year: "2025",
    headline: "Everything Clicked.",
    copy: [
      "The game slowed down. The confidence grew. The work started showing.",
      "MVP. Championships. Scoring titles.",
      "Everything I prayed for and worked for started coming together.",
      "But I'm nowhere near finished.",
    ],
    achievements: [
      "League MVP",
      "#1 Scorer",
      "BCB Champion",
      "BUCS Champion",
      "All-Star Leading Scorer",
    ],
    image: IMAGES.newcastle,
    coords: { x: 47, y: 30 },
  },
  {
    flag: "🇦🇱",
    place: "FIER, ALBANIA",
    year: "2026",
    headline: "New City. Same Energy.",
    copy: [
      "Welcome to the Super League.",
      "A new city, bringing the same energy.",
      "Signed with Apolonia Fier. New colors, same mission.",
      "One Of None.",
    ],
    achievements: ["Apolonia Fier", "Albanian Super League"],
    image: IMAGES.yearThree,
    coords: { x: 66, y: 42 },
  },
];

export const PLAYER_INFO = [
  { label: "Position", value: "Swingman" },
  { label: "Height", value: "6'6\"" },
  { label: "Weight", value: "204 lbs" },
  { label: "Nationality", value: "USA 🇺🇸" },
];

export const STRENGTHS = [
  "Three-Level Scorer",
  "Shot Creation",
  "Athleticism",
  "Transition Offense",
  "Basketball IQ",
  "Leadership",
  "Competitive Motor",
];

export const PRODUCTS = [
  {
    name: "One Of None Hoodie",
    price: "$68",
    image:
      "https://images.unsplash.com/photo-1610392462690-84766bd687ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "One Of None Tee",
    price: "$34",
    image:
      "https://images.unsplash.com/photo-1614214191247-5b2d3a734f1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "Built Overseas Collection",
    price: "$54",
    image:
      "https://images.unsplash.com/photo-1610582144787-eda2e6f293b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "Travel Collection",
    price: "$72",
    image:
      "https://images.unsplash.com/photo-1448582649076-3981753123b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const PARTNERSHIP_CATEGORIES = [
  "Athletic Apparel",
  "Recovery",
  "Travel",
  "Performance Nutrition",
  "Technology",
  "Basketball",
];

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/jaronthames/" },
  { label: "TikTok", href: "https://www.tiktok.com/@jarondo_" },
  { label: "X", href: "https://x.com/JaRonThames24" },
];
